<template>
  <b-icon icon="pencil" />
</template>

<script >
export default {name:"EditIcon",}
</script>
